<template>
  <div :class="{ 'tw:border-b tw:border-gray-300 tw:pb-6 tw:mb-6': !isLast }">
    <h1 class="tw:font-bold tw:text-xl tw:mb-3">{{ title }}</h1>
    <slot />
  </div>
</template>
<script setup>
defineProps({
  title: String,
  isLast: Boolean,
})
</script>
